import React, { useEffect, useState } from 'react';
import './dashboard.css';
import profit from '../../Assets/icon/profit.svg'
import client from '../../Assets/icon/clieints2.svg'
import reseller from '../../Assets/icon/resellers.svg'
import productOrder from '../../Assets/icon/product orders.svg'
import GradientStackedAreaChart from './GradientStackedAreaChart';
import PieChart from './PieChart';
import { Height } from '@mui/icons-material';
import api from '../../axiosInstance';
import useTotalInvestment from '../../Hook/useTotalInvestment';
function Dashboard() {
  const { totalInvestment, dashboardData, loading, error } = useTotalInvestment();


  const formatAmount = (num) => {
    if (num >= 10000000) {
      return (num / 10000000).toFixed(2).replace(/\.00$/, '') + "Cr"; // Crores
    } else if (num >= 100000) {
      return (num / 100000).toFixed(2).replace(/\.00$/, '') + "L";   // Lakhs
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2).replace(/\.00$/, '') + "K";     // Thousands
    }
    return num.toString();
  };

  console.log("Total12", dashboardData);
  return (
    <div className='distributerfont'>
      <div className='row'>
        <div className='col-md-12 col-12'>
          <h3 className='distributerfont'>Dashboard</h3>
          <div className='rounded-3 p-3'>
            <div className="rounded-3">
              <div className='row'>
                <div className='col-md-3 col-6 my-2'>
                  <div className='rounded-5 p-3 Profit-bg-color'>
                    <div className='d-flex justify-content-between'>
                      <img src={profit} width={50} alt="" srcset="" />
                      <label htmlFor="" style={{ fontFamily: "'Roboto', sans-serif", fontWeight: 900 }}>{totalInvestment}</label>
                    </div>

                    <h5>Investment</h5>
                    <div className="progress" role="progressbar" aria-label="Basic example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                      <div className="progress-bar bg-white w-75"></div>
                    </div>
                    <div>
                      <h1 className='text-center' style={{ fontFamily: "'Roboto', sans-serif" }}>{ formatAmount(Number(totalInvestment))}</h1>

                    </div>
                  </div>
                </div>
                <div className='col-md-3 col-6 my-2'>
                  <div className='rounded-5 p-3 client-bg-color'>
                    <img src={client} width={50} alt="" srcset="" />
                    <h5>Client</h5>
                    <div className="progress" role="progressbar" aria-label="Basic example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                      <div className="progress-bar bg-white w-75"></div>
                    </div>
                    <div>
                      <h1 className='text-center' style={{ fontFamily: "'Roboto', sans-serif" }}>{dashboardData?.client}</h1>
                    </div>
                  </div>
                </div>
                <div className='col-md-3 col-6 my-2'>
                  <div className='rounded-5 p-3 reseller-bg-color'>
                    <img src={reseller} width={50} alt="" srcset="" />
                    <h5>Reseller</h5>
                    <div className="progress" role="progressbar" aria-label="Basic example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                      <div className="progress-bar bg-white w-75"></div>
                    </div>
                    <div>
                      <h1 className='text-center' style={{ fontFamily: "'Roboto', sans-serif" }}>{dashboardData?.reseller}</h1>
                    </div>
                  </div>
                </div>
                <div className='col-md-3 col-6 my-2'>
                  <div className='rounded-5 p-3 productOrder-bg-color'>
                    <img src={productOrder} width={50} alt="" srcset="" />
                    <h5>Product Orders</h5>
                    <div className="progress" role="progressbar" aria-label="Basic example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                      <div className="progress-bar bg-white w-75"></div>
                    </div>
                    <div>
                      <h1 className='text-center' style={{ fontFamily: "'Roboto', sans-serif" }}>{dashboardData?.product}</h1>
                    </div>
                  </div>
                </div>
                <div className='col-12 shadow rounded-4 mt-2' style={{ overflowY: 'auto' }}><GradientStackedAreaChart /></div>
                {/* <div className='col-6 shadow rounded-4'><PieChart /></div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <div className='col-md-3 col-12 distributerSideimage rounded-5 mt-md-0 mt-2 distributerfont'>
          <div className='bg-white my-4 mx-2 p-3 rounded-5'>
            <h5>Details</h5>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam praesentium vel harum tempore eaque asperiores? Delectus voluptatum eligendi tempore fugit labore, officiis reiciendis, deserunt sunt cupiditate, minus sed omnis eveniet.</p>
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default Dashboard